module.exports = __webpack_public_path__ + "static/media/zahir-namane-YTsEZrHqDq0-unsplash.878b833b.jpg";